import React from "react";
import InterfacesReport from "./Report";
import View from "common/View";
import help from "help/viewIfaceStkStats.md";

const Interfaces = ({ returnView = null }) => (
  <View
    title="Network Interface Ports Throughput Over Time"
    bodyPanelLayout="row"
    mdHelp={help}
    returnView={returnView}
  >
    <InterfacesReport />
  </View>
);

export default Interfaces;
